"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Pagination_component_exports = {};
__export(Pagination_component_exports, {
  Pagination: () => Pagination
});
module.exports = __toCommonJS(Pagination_component_exports);
var import_react = __toESM(require("react"));
var import_react_paginate = __toESM(require("react-paginate"));
var import_useEventListener = require("../../../utils/useEventListener/useEventListener.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_react_i18next = require("react-i18next");
var import_useMutationObserver = require("../../../utils/useMutationObserver/useMutationObserver.hook");
var import_ScreenReaderOnlyText = require("../../atoms/ScreenReaderOnlyText/ScreenReaderOnlyText.component");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_Pagination = require("./Pagination.styled");
var import_BreakLabel = __toESM(require("./BreakLabel.component"));
var _excluded = ["currentPage", "totalPages", "onPageChange", "darkMode", "ariaLiveForArrowEnterPress"];
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0, F = function F2() {
      };
      return { s: F, n: function n() {
        return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
      }, e: function e2(r2) {
        throw r2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r);
  }, n: function n() {
    var r2 = t.next();
    return a = r2.done, r2;
  }, e: function e2(r2) {
    u = true, o = r2;
  }, f: function f() {
    try {
      a || null == t["return"] || t["return"]();
    } finally {
      if (u)
        throw o;
    }
  } };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var _matchMedia = (0, import_Helpers.matchMedia)(), small = _matchMedia.small, medium = _matchMedia.medium, desktop = _matchMedia.desktop;
var smallRanges = {
  range: 0,
  margin: 0
};
var mediumRanges = {
  range: 1,
  margin: 1
};
var largeRanges = {
  range: 4,
  margin: 1
};
var Pagination = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref, componentRef) {
  var currentPage = _ref.currentPage, totalPages = _ref.totalPages, onPageChange = _ref.onPageChange, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$ariaLiveForArrow = _ref.ariaLiveForArrowEnterPress, ariaLiveForArrowEnterPress = _ref$ariaLiveForArrow === void 0 ? "assertive" : _ref$ariaLiveForArrow, props = _objectWithoutProperties(_ref, _excluded);
  var chevronSize = 30;
  var ref = (0, import_react.useRef)(null);
  var _useState = (0, import_react.useState)(0), _useState2 = _slicedToArray(_useState, 2), currentPageNo = _useState2[0], setCurrentPageNo = _useState2[1];
  var _useState3 = (0, import_react.useState)("0"), _useState4 = _slicedToArray(_useState3, 2), readAriaLabelOnPgChange = _useState4[0], setReadAriaLabelOnPgChange = _useState4[1];
  var _useState5 = (0, import_react.useState)(4), _useState6 = _slicedToArray(_useState5, 2), altPageRange = _useState6[0], setAltPageRange = _useState6[1];
  var _useState7 = (0, import_react.useState)(1), _useState8 = _slicedToArray(_useState7, 2), altMarginPages = _useState8[0], setAltMarginPages = _useState8[1];
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var activeClassName = "active";
  var pageLinkClassName = "link";
  var breakClassName = "break-item";
  var containerClassName = "pagination";
  var pageClassName = "item";
  var checkMedia = function checkMedia2() {
    if (small.matches) {
      setAltPageRange(smallRanges.range);
      setAltMarginPages(smallRanges.margin);
    }
    if (medium.matches) {
      setAltPageRange(mediumRanges.range);
      setAltMarginPages(mediumRanges.margin);
    }
    if (desktop.matches) {
      setAltPageRange(largeRanges.range);
      setAltMarginPages(largeRanges.margin);
    }
  };
  var setDpAnalyticsIds = function setDpAnalyticsIds2(_ref2) {
    var current = _ref2.current;
    var arrowPrev = current === null || current === void 0 ? void 0 : current.querySelector('a[rel="prev"]');
    var arrowNext = current === null || current === void 0 ? void 0 : current.querySelector('a[rel="next"]');
    var dataDpAnalyticsId = props.dataDpAnalyticsId;
    var pages = current === null || current === void 0 ? void 0 : current.querySelectorAll("ul.".concat(containerClassName, " li a.").concat(pageLinkClassName, ", ul.").concat(containerClassName, " li.").concat(breakClassName, " a span, ul.").concat(containerClassName, " li.").concat(breakClassName, ' a div[role="listbox"] li[role="menuitem"]'));
    pages === null || pages === void 0 || pages.forEach(function(page) {
      return page.setAttribute("data-dp-analytics-id", "".concat(dataDpAnalyticsId, "-").concat(page.textContent.replace(/[^0-9]/g, "")));
    });
    arrowPrev === null || arrowPrev === void 0 || arrowPrev.setAttribute("data-dp-analytics-id", "".concat(dataDpAnalyticsId, "-").concat(currentPage !== 0 && currentPage));
    arrowNext === null || arrowNext === void 0 || arrowNext.setAttribute("data-dp-analytics-id", "".concat(dataDpAnalyticsId, "-").concat(currentPage + 2));
  };
  var loadDpAnalyticsIds = function loadDpAnalyticsIds2() {
    if (ref && props.dataDpAnalyticsId) {
      setTimeout(function() {
        return setDpAnalyticsIds(ref);
      }, 100);
    }
  };
  (0, import_react.useEffect)(function() {
    loadDpAnalyticsIds();
    setCurrentPageNo(currentPage);
  }, [currentPage]);
  (0, import_react.useEffect)(function() {
    checkMedia();
    loadDpAnalyticsIds();
  }, []);
  (0, import_useEventListener.useEventListener)("resize", function() {
    checkMedia();
  });
  (0, import_react.useEffect)(function() {
    var rightArrowButton = ref.current.firstChild.lastChild;
    var leftArrowButton = ref.current.firstChild.firstChild;
    var rightArrowListener = function rightArrowListener2(event) {
      if (event.key === " " || event.key === "Enter") {
        if (currentPageNo + 2 <= totalPages) {
          setReadAriaLabelOnPgChange("".concat(currentPageNo + 2));
        }
        if (currentPageNo + 2 === totalPages) {
          setReadAriaLabelOnPgChange("".concat(currentPageNo + 2, ", last page"));
        }
      }
    };
    var leftArrowListener = function leftArrowListener2(event) {
      if (event.key === " " || event.key === "Enter") {
        if (currentPageNo > 0) {
          setReadAriaLabelOnPgChange("".concat(currentPageNo));
        }
        if (currentPageNo === 1) {
          setReadAriaLabelOnPgChange("".concat(currentPageNo, ", first page"));
        }
      }
    };
    rightArrowButton.addEventListener("keydown", rightArrowListener);
    leftArrowButton.addEventListener("keydown", leftArrowListener);
    return function() {
      rightArrowButton.removeEventListener("keydown", rightArrowListener);
      leftArrowButton.removeEventListener("keydown", leftArrowListener);
    };
  }, [currentPageNo]);
  (0, import_react.useEffect)(function() {
    var _ref$current;
    var ulItem = ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("ul.".concat(containerClassName));
    ulItem === null || ulItem === void 0 || ulItem.removeAttribute("role");
  }, []);
  var handleMutations = function handleMutations2(mutationsList) {
    var _iterator = _createForOfIteratorHelper(mutationsList), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var mutation = _step.value;
        if (mutation.type === "childList") {
          var _ref$current2;
          var pageSelected = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.querySelector("ul.".concat(containerClassName, " li.").concat(activeClassName, " a.").concat(pageLinkClassName));
          pageSelected === null || pageSelected === void 0 || pageSelected.setAttribute("tabindex", "0");
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  (0, import_useMutationObserver.useMutationObserver)(ref, handleMutations);
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_ScreenReaderOnlyText.ScreenReaderOnlyText, {
    text: "Changed to page number ".concat(readAriaLabelOnPgChange),
    "aria-live": ariaLiveForArrowEnterPress
  }), /* @__PURE__ */ import_react.default.createElement(import_Pagination.StyledAllToolsContainer, {
    ref: componentRef
  }, /* @__PURE__ */ import_react.default.createElement(import_Pagination.StyledPaginateContainer, {
    role: "navigation",
    darkMode,
    "data-testid": "pagination-container",
    ref
  }, /* @__PURE__ */ import_react.default.createElement(import_react_paginate.default, {
    previousLabel: /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
      icon: "chevron-back",
      size: chevronSize
    }),
    nextLabel: /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
      icon: "chevron-front",
      size: chevronSize
    }),
    previousClassName: "chevron-front",
    previousLinkClassName: "chevron-link prev",
    nextLinkClassName: "chevron-link next",
    disabledClassName: "chevron-disable",
    previousAriaLabel: t("base_action_previous"),
    ariaLabelBuilder: function ariaLabelBuilder(page) {
      return "".concat(t("base_glossary_page"), " ").concat(page);
    },
    nextAriaLabel: t("base_action_next"),
    marginPagesDisplayed: altMarginPages,
    pageRangeDisplayed: altPageRange,
    containerClassName,
    pageClassName,
    pageLinkClassName,
    activeClassName,
    breakClassName,
    breakAriaLabels: {
      forward: null,
      backward: null
    },
    breakLabel: /* @__PURE__ */ import_react.default.createElement(import_BreakLabel.default, {
      currentPage: currentPageNo,
      totalPages,
      marginPages: altMarginPages,
      pageRange: altPageRange,
      onPageChange
    }),
    pageCount: totalPages,
    onPageChange,
    forcePage: currentPageNo
  }))));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Pagination
});
//# sourceMappingURL=Pagination.component.js.map